
import { defineComponent, ref } from 'vue'
import UIkit from 'uikit'
import store from '@/store'
import TemplateSlugForm from '@/components/Shared/Form/TemplateSlugForm.vue'

export default defineComponent({
  components: {
    TemplateSlugForm
  },
  props: {
    submittable: { type: Boolean, default: true }
  },
  emits: ['submit'],
  setup(props, { emit }) {
    const modalId = 'template-slug-modal'
    const showForm = ref(false)

    const hideModal = () => {
      const modal = document.getElementById(modalId)
      UIkit.modal(modal!).hide()
    }

    const submitHandler = (slug: string) => {
      if (!props.submittable) return

      emit('submit', slug)
      hideModal()
    }

    return {
      store,
      modalId,
      showForm,
      submitHandler
    }
  }
})
